module.exports = {"id":"196143","name":"Dorlan Pabón","rating":"77","photo":"./data/images/photos/1/196143.png","club":{"name":"Monterrey","logo":"./data/images/clubs/Monterrey.png"},"positions":["AG","BU","MOC","AD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DorlanPabon0.json
// module id = 1143
// module chunks = 0